<template>
  <div id="pos" ref="start" class="pospage">
    <div id="leftNav" class="sidenav">
      <router-link to="/" id="unsecured">UNSECURED</router-link>
    </div>
    <div id="rightNav" class="sidenav2">
      <router-link to="/secured" id="secured">SECURED</router-link>
    </div> 
    <NavBar mainPage = "true" />
    <section id="header" class="fullpage pos-header" ref="posstart">
      <Header
        id="header "
        :title="header.title"
        :info="header.infos"
        :additionalInfo="header.additionalInfo"
        :mainPage="mainPage"
      />
    </section>
    <section id="features" class="features fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="features-head">
          <p>Device Features</p>
        </div>
      </div>
      <div class="features-mid-section">
        <ProductServices
          class="dev-features"
          :Services="Features"
          :subheading="subheading"
          showmode="true"
        />
      </div>
    </section>
    <section id="pos-device" class="pos-device fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="pos-device-head">
          <p>ftcash PoS K300</p>
        </div>
      </div>
      <div class="pos-device-mid-section">
        <Posdevice class="pos-dev" />
      </div>
    </section>
    <section id="why-pos" class="why-pos fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="why-pos-head">
          <p>Why Choose PoS?</p>
        </div>
      </div>
      <div class="choose-pos-mid-section">
        <ProductServices class="choose-pos" :Services="choosePos" />
      </div>
    </section>
    <section id="payment-methods" class="payment-methods fullpage mid">
      <div id="testimonial-title" class="awards-title-section color_white w-100 testimonial-text">
        <div class="awards-img">
          <img class="features-image-bg" alt="Headings Image" :src="require(`@/assets/img/testimonial-text-bg.png`)" />
        </div>
        <div class="payment-methods-head">
          <p>Payment Methods</p>
        </div>
      </div>
      <div class="pay-method-mid-section">
        <ProductServices class="pay-method" :Services="paymentMethods" />
      </div>
    </section>
    <section id="foot" class="fullpage" ref="footerSection" v-lazy:background-image ="require(`@/assets/background/footer_bg.png`)">
      <Footer />
    </section>
  </div>
</template>
<script>
import ProductServices from "../individual/product-services";
import Posdevice from "./pos-device";
export default {
  name: "Pos",
  components: {
    ProductServices,
    Posdevice,
  },
  data() {
    return {
      inMove: false,
      activeSection: 0,
      offsets: [],
      touchStartY: 0,
      mainPage: true,
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.25, // [0.25, 0.75] if you want a 25% offset!
      },
      headings: {
        features: "Device Features",
        choosePosHeader: "Why Choose PoS?",
        paymentMethodsHeader: "Payment Methods",
      },
      subheading:
        "A complete digital payments solution that helps you to pay your loans too!",
      header: {
        title: "Go Digital with our stand-alone Point of Sale machine",
        infos: "                                           ",
        additionalInfo: [
          "Accepts all card payments",
          "Works on Wi-Fi and GPRS connectivity",
        ],
      },
      Features: [
        {
          image: "cards.png",
          infos: "Accepts all domestic cards",
          additional:
            "Receive payments with all types of cards such as Debit/Credit/Contactless",
        },
        {
          image: "wifi.png",
          infos: "WiFi and Mobile Connectivity",
          additional:
            "Dual Connectivity, particularly useful for areas with low mobile connectivity",
        },
        {
          image: "battery.png",
          infos: "Long Battery Life",
          additional: "Extended Battery Life of 12 hours in a single charge",
        },
      ],
      choosePos: [
        {
          image: "paperless.png",
          infos: "Paperless Transactions",
          additional:
            "Send a digital copy of the receipt to your customers instantly",
        },
        {
          image: "edi.png",
          infos: "EDI loans",
          additional:
            "You can give customer an EDI (Equated Daily Installments) loan and convert it into an EDI purchase",
        },
        {
          image: "digital-mobile.png",
          infos: "Make your business digital",
          additional:
            "Accept all digital payments with ftcash pos billing machine and let your business flourish with digital modes",
        },
      ],
      paymentMethods: [
        {
          image: "QR-code.png",
          infos: "QR code",
          additional:
            "No need for a physical card, now your customers can scan and pay the bill!",
        },
        {
          image: "POS-money.png",
          infos: "One machine for all cards",
          additional:
            "Skip the hassle of buying and maintaining different machines for different cards",
        },
        // {
        //   image: 'POS-QR.png',
        //   infos: 'Connect PoS with the app',
        //   additional: 'Forget the paperwork! Our ftcash app and PoS machine keep detailed records of all the transactions'
        // },
        {
          image: "ftpay-link.png",
          infos: "ftPay Link",
          additional:
            "Accept remote payments and ensure timely processing of invoices",
        },
      ],
    };
  },
  created() {},
  mounted() {
    // if (localStorage.getItem('reloaded')) {
    //     // The page was just reloaded. Clear the value from local storage
    //     // so that it will reload the next time this page is visited.
    //     localStorage.removeItem('reloaded');
    // } else {
    //     // Set a flag so that we know not to reload the page twice.
    //     localStorage.setItem('reloaded', '1');
    //     location.reload();
    // }
    //  var scroll = document.getElementById("app").scrollTop;
    //  console.log(scroll)
    //  document.getElementById("app").scrollTop=0;
    //   document.querySelector('.pos-header').scrollIntoView({ 
    //     behavior: 'smooth' 
    //   });
    // window.scrollTo(0,0)
    //document.getElementById('scroll-anchor').click();
    this.$refs.posstart.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
   // window.scrollTo(0, 0);
   
  },
  metaInfo() {
    return{
    meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Apply for ftcash stand-alone PoS machine and experience the cashless transaction. It accepts all forms of cards, & works on Wi-Fi and GPRS connectivity.ftcash's PoS machine - An online payment solution that accepts all forms of cards, & works on Wi-Fi and GPRS connectivity. And, helps you to pay your loan easily."
        }
      ],
    link: [
      { rel: 'canonical', href: 'https://www.ftcash.com/pos' },
    ],
    }
  },
};
</script>

<style scoped>
.fake-anchor{
  display:none;
}
/* Tag CSS */

/* ID CSS */
.pos-header {
  height: 100vh;
  width: 100%;
  background-image: linear-gradient(rgba(0, 0, 0, 0.33), rgba(0, 0, 0, 0.78)),
    url("../../assets/background/pos_bg.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
}
#leftNav a {
  position: fixed;
  z-index: 1;
  left: 0px;
  width: 36px;
  height: 219px;
  font-size: 1rem;
  writing-mode: vertical-rl;
  text-orientation: upright;
   -webkit-text-orientation: upright;
  color: var(--mainWhiteColor);
  border-radius: 0 5px 5px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  text-decoration: none;
}
#leftNav a:hover {
  box-shadow: 0px 0px 8px rgb(31 61 113);
}

#unsecured {
  top: 37%;
  background-color: var(--mainBlueColor);
}
#rightNav a {
  position: fixed;
  z-index: 1;
  right: 0px;
  width: 36px;
  height: 219px;
  writing-mode: vertical-rl;
  text-orientation: upright;
   -webkit-text-orientation: upright;
  font-size: 1rem;
  color: var(--mainWhiteColor);
  border-radius: 5px 0 0 5px;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
#rightNav a:hover {
  box-shadow: 0px 0px 8px rgb(31 61 113);
}
#secured {
  top: 37%;
  background-color: var(--mainBlueColor);
}

/* Class CSS */
/* Features */
.features,
.pos-device,
.why-pos,
.payment-methods {
  position: relative;
}
.features-image-bg {
  width: 92px;
  height: 114px;
  float: right;
}
.features-head {
  font-size: 3.3rem;
  position: absolute;
  right: 66px;
  float: right;
  z-index: 2;
  top: 47px;
}
/* PoS Device Required */
.pos-device-head {
  font-size: 3.3rem;
  position: absolute;
  right: 59px;
  float: right;
  z-index: 2;
  top: 46px;
}
/* Why Choose PoS */
.why-pos-head {
  font-size: 3.3rem;
  position: absolute;
  right: 62px;
  float: right;
  z-index: 2;
  top: 46px;
}
/* Payment Methods */
.payment-methods-head {
  font-size: 3.3rem;
  position: absolute;
  right: 65px;
  float: right;
  z-index: 2;
  top: 46px;
}
/*Mid Sections*/
.features-mid-section, .pos-device-mid-section, .choose-pos-mid-section, .pay-method-mid-section {
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: 1;
}
/* Awards & Media */
.awards-title-section {
  width: 100vw;
  min-height: 114px;
  background-image: url("../../assets/background/awards_bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  -o-background-size: cover;
  -moz-background-size: cover;
  -webkit-background-size: cover;
  z-index: -2;
}
.award-title {
  font-size: 3.5rem;
  padding-bottom: 0;
  margin-bottom: 0;
  line-height: 0.7;
  float: right;
}
.awards-image-bg {
  width: 160px;
  height: 130px;
  float: right;
}
.awards-head {
  font-size: 3.3rem;
  bottom: -19%;
  position: absolute;
  right: 133px;
}
.awards-img {
  right: 0;
  z-index: -1;
}
.media-head {
  font-size: 3.3rem;
  bottom: -19%;
  position: absolute;
  right: 134px;
}
.color_white {
  color: white;
}
/* External Partners */
.partners-head {
  font-size: 3.3rem;
  bottom: -19%;
  position: absolute;
  right: 67px;
}

/* Media Queries */
/* Tablet View */
@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .pos-header {
    display: flex !important;
    align-items: center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
      url("../../assets/background/pos_bg.jpg");
    background-size: cover;
    background-position: 50% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  /*.mid {
    padding: 10% 0;
  }
  .dev-features,
  .pos-dev,
  .choose-pos,
  .pay-method {
    margin-top: 25px;
  }*/
  /* Features */
  .features,
  .pos-device,
  .why-pos,
  .payment-methods {
    position: relative;
  }
  .features-image-bg {
    width: 36px;
    height: 114px;
  }
  .features-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  /* PoS Device Required */
  .pos-device-head, .why-pos-head, .payment-methods-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 1.25rem 0rem;
    width: 100%;
    text-align: center;
    bottom: 0;
    right: 0;
    float: none;
  }
  
  .awards-title-section {
   top: 0;
    z-index: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-head {
    font-size: 1.75rem;
    position: static;
  }
  .awards-img {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 0;
  }
  .color_white {
    color: white;
  }
  .features-mid-section {
    background-color: transparent;
  }
  .choose-pos-mid-section {
    background-color: transparent;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .pos-header {
    background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
      url("../../assets/background/pos_bg.jpg");
    background-size: cover;
    background-position: 50% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
}
/* Mobile View */
@media (min-width: 481px) and (max-width: 767px) {
  .pos-header {
    display: flex !important;
    align-items: center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
      url("../../assets/background/pos_bg.jpg");
    background-size: cover;
    background-position: 50% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  section:nth-child(odd):nth-last-child(n + 3) {
      z-index: 2;
  }
  .mid {
    padding: 10% 0;
  }

  .dev-features,
  .pos-dev,
  .choose-pos,
  .pay-method {
    margin-top: 25px;
  }
  /* Features */
  .features,
  .pos-device,
  .why-pos,
  .payment-methods {
    position: relative;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .features-head, .pos-device-head, .why-pos-head, .payment-methods-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }
  /* Map */
  .map-head {
    font-size: 1.75rem;
    position: static;
  }
  /* Gallery */
  .recog-head {
    font-size: 1.75rem;
    position: static;
    padding: 0.5rem 0;
  }
  /* Awards & Media */
  .awards-main-section {
    margin-top: 7rem;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-head {
    font-size: 1.75rem;
    position: static;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .color_white {
    color: white;
  }

  .features-mid-section {
    background-color: transparent;
  }
  .choose-pos-mid-section {
    background-color: transparent;
  }
}
@media (max-width: 480px) {
  .pos-header {
    display: flex !important;
    align-items: center;
    background-image: linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)),
      url("../../assets/background/pos_bg.jpg");
    background-size: cover;
    background-position: 50% 50%;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
  }
  #leftNav,
  #rightNav {
    display: none;
  }
  section:nth-child(odd):nth-last-child(n + 3) {
      z-index: 2;
  }
  .mid {
    padding: 10% 0;
  }

  .dev-features,
  .pos-dev,
  .choose-pos,
  .pay-method {
    margin-top: 45px;
  }
  /* Features */
  .features,
  .pos-device,
  .why-pos,
  .payment-methods {
    position: relative;
  }
  .features-image-bg {
    width: 36px;
    height: 60px;
  }
  .features-head, .pos-device-head, .why-pos-head, .payment-methods-head {
    font-size: 1.75rem;
    position: absolute;
    padding: 0.5rem 0rem;
    width: 100%;
    text-align: center;
    top: 0;
    right: 0;
    float: none;
  }

  /* Awards & Media */
  .awards-main-section {
    margin-top: 7rem;
  }
  .awards-title-section {
    width: 100vw;
    min-height: 60px;
    background-image: url("../../assets/background/awards_bg.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    -o-background-size: cover;
    -moz-background-size: cover;
    -webkit-background-size: cover;
    position: absolute;
    top: 0;
  }
  .award-title {
    font-size: 3.5rem;
    padding-bottom: 0;
    margin-bottom: 0;
    line-height: 0.7;
    float: right;
  }
  .awards-image-bg {
    width: 160px;
    height: 130px;
    float: right;
  }
  .awards-head {
    font-size: 1.75rem;
    position: static;
  }
  .awards-img {
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .color_white {
    color: white;
  }
  .features-mid-section {
    background-color: transparent;
  }
  .choose-pos-mid-section {
    background-color: transparent;
  }
}
</style>
